import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getSubscribeUserApi = (params) => {
  return httpService({
    url: contextPath + '/subscribe/subscriber/info',
    method: 'get',
    params
  })
}

export const getSubscribeListApi = (params) => {
  return httpService({
    url: contextPath + '/subscribe/record/info',
    method: 'get',
    params
  })
}

export const getSubscribeListByUserApi = (params) => {
  return httpService({
    url: contextPath + '/subscribe/record/info/withoutSubscribe',
    method: 'get',
    params
  })
}

export const saveSubscribeListByUserApi = (data) => {
  return httpService({
    url: contextPath + '/subscribe/record/list',
    method: 'post',
    data
  })
}

export const cancelSubscribeApi = (params) => {
  return httpService({
    url: contextPath + '/subscribe/record/item/cancelSubscribe',
    method: 'put',
    params
  })
}

export const reSubscribeApi = (params) => {
  return httpService({
    url: contextPath + '/subscribe/record/item/subscribeAgain',
    method: 'put',
    params
  })
}

export const deleteSubscribeApi = (params) => {
  return httpService({
    url: contextPath + '/subscribe/record/item',
    method: 'delete',
    params
  })
}

export const modifySubscriberApi = (data) => {
  return httpService({
    url: contextPath + '/subscribe/subscriber/item',
    method: 'put',
    data
  })
}

export const getUserInfo = (params) => {
  return httpService({
    url: contextPath + '/subscribe/subscriber/subscribeConfig',
    method: 'get',
    params
  })
}
